<vs-card theme="default" class="block @container">
  <vs-card-header
    class="[&>div]:!flex-wrap [&>div>div:first-child]:!min-w-[200px] [&>div>div:first-child>div]:!flex-nowrap !py-3 @xl:!py-4 !px-4 @xl:!px-5"
    [config]="{ title: config.title, subtitle: config.subtitle }"
  >
    <vs-badge slot="after-title">
      {{ totalItems === null ? config.loadingBadge : (totalItems | number) + ' ' + (totalItems === 1 ?
      config.paymentSingular : config.paymentPlural) }}
    </vs-badge>

    <a
      *ngIf="exportUrl$ | async as exportUrl"
      vs-button
      size="md"
      slot="end"
      appearance="outline"
      [href]="exportUrl"
      download
    >
      <vs-icon name="download-01"></vs-icon>
      {{ config.exportCsv }}
    </a>
  </vs-card-header>

  <vs-card-content>
    <!-- Filters -->
    <div class="flex justify-between gap-4 mb-4" *vsLet="filters$ | async as filters">
      <div class="flex gap-4 flex-wrap">
        <vs-input-container class="!w-[260px] flex-grow-0">
          <vs-icon name="search-lg" slot="start"></vs-icon>
          <input
            #searchInput
            type="text"
            [placeholder]="config.searchPlaceholder"
            [value]="search$ | async"
            (input)="onSearchInput(searchInput.value)"
          />
        </vs-input-container>

        <vs-select
          vsInput
          class="min-w-[212px]"
          [value]="filters?.status"
          [config]="{ placeholder: config.statusPlaceholder, allowDeselect: true }"
          (valueChanges)="onStatusChange($event)"
        >
          <li *ngFor="let status of statuses" vs-select-option [value]="status">{{ statusLabels[status] }}</li>
        </vs-select>

        <button
          type="button"
          class="flex items-center gap-2 border border-gray-300 rounded-lg px-3 py-2 bg-white min-w-[240px] hover:border-gray-400 transition-colors"
          [vsMenuTriggerFor]="dateRangeMenu"
        >
          <vs-icon name="calendar" class="text-gray-400" size="16"></vs-icon>
          <div class="flex-1 text-left text-sm">
            <ng-container *ngIf="filters?.startDate || filters?.endDate; else noDateRange">
              <span class="text-gray-900">
                {{ filters?.startDate ? (filters?.startDate | date: 'MMM d') : config.dateRangeStart }} - {{
                filters?.endDate ? (filters?.endDate | date: 'MMM d, y') : config.dateRangeEnd }}
              </span>
            </ng-container>
            <ng-template #noDateRange>
              <span class="text-gray-500">{{ config.dateRangePlaceholder }}</span>
            </ng-template>
          </div>
          <vs-icon name="chevron-down" class="text-gray-400" size="14"></vs-icon>
        </button>

        <ng-template #dateRangeMenu>
          <vs-menu class="!z-50">
            <div class="p-4">
              <vs-date-picker [range]="true" (selectionChanged)="onDateRangeChange($event)"></vs-date-picker>
            </div>
          </vs-menu>
        </ng-template>
      </div>

      <button *ngIf="hasFilters$ | async" vs-button appearance="clear" size="md" (click)="clearFilters()">
        <vs-icon name="x-close" size="16"></vs-icon>
        {{ config.clear }}
      </button>
    </div>

    <vs-connected-table
      [endpoint]="endpoint$ | async"
      [columns]="columns"
      [queryParams]="queryParams$ | async"
      (rowClicked)="openDetail($any($event))"
      (padeLoaded)="onPageLoaded($any($event))"
    ></vs-connected-table>
  </vs-card-content>
</vs-card>

<ws-payment-history-detail-dialog></ws-payment-history-detail-dialog>
